import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AuthSelectors, AuthDispatchers } from '@store';
import { AdminService } from '../store/services/admin.service';
import { IndexCard } from '@store/models';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-impersonate',
    template: `
        <app-impersonate-ui
            [users]="users$ | async"
            [userId]="userId$ | async"
            [offices]="offices$ | async"
            [officeId]="officeId$ | async"
            [officeName]="officeName$ | async"
            (getUsers)="getUsers($event)"
            (impersonate)="impersonate($event)"
        ></app-impersonate-ui>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ImpersonateContainer {

    userId$ = this.authSelector.userId$;
    officeId$ = this.authSelector.officeId$;
    officeName$ = this.authSelector.officeName$;
    offices$ = this.adminService.getOffices();
    users$: Observable<IndexCard[]>;

    constructor(
        private authSelector: AuthSelectors,
        private authDispatch: AuthDispatchers,
        private adminService: AdminService
    ) {}

    getUsers(officeId: number) {
        this.users$ = this.adminService.getUsers(officeId);
    }

    impersonate(ADuser: string) {
        this.authDispatch.impersonate(ADuser);
    }

}
